export default {
    '1a-diagram1': {
        'diagram-task': 'Press Complete and watch the pyramid display the correct structure',
        'element_1_1': 'Permits DC to attend',
        'element_1_2': 'More convenient for JC and HJ',
        'element_1_3': 'Reschedule today’s meeting to Thursday at 11:00',
        'element_1_4': 'Room free',
        'complete-title': 'Complete',
        'next-title': 'Next',
        'diagram-message': 'Try it yourself in the next 3 exercises'
    }
};



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1a/diagram1/i18n/en.js